import { useMediaQuery } from "react-responsive";

const Progress = ({ value }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const parsed = parseInt(value);

  return (
    <div className="progress">
      <span className="progress--line" style={{ width: `calc(${parsed}% ${isMobile ? '- 24px' : '- 45px'})` }}></span>
      {parsed > 0 && (
        <span
          className="progress--indicator"
          style={{ left: `calc(${parsed}% - 45px)` }}
        >
          {`${parsed}%`}
        </span>
      )}
    </div>
  );
};

export default Progress;